import { getVfDictItems } from '@/CommonDP/service/vf-component-service';
import { V_FORM_ENUM, extendsSchema } from '@/CommonDP/VForm/utils';
export const VF_DICT_ENUM = {
  root: 'root',
  label: '${label}',
  key: '${key}',
  key_Label: '${key}-${label}'
};
export const schema = {
  group: V_FORM_ENUM.custom,
  type: 'jy-dict',
  icon: 'select-field',
  label: '字典',
  formItemFlag: true,
  component: require('./index.vue').default,
  props() {
    const props = {
      setting: () => import('./setting.vue')
    };
    return props;
  },
  // 事件名 :[事件参数]
  events() {
    return {
      onMounted: [],
      onQuery: [],
      onChange: ['value', 'label'],
      onValidate: ['rule', 'value', 'callback']
    };
  },
  getSFC: () => {
    return '<div></div>';
  },
  zh: {
    dict: {
      label: '标签名称'
    }
  },
  options: {
    name: '',
    label: '字典选择',
    requiredHint: ' ',
    labelHidden: false,
    labelWidth: '',
    required: false,
    disabled: false,
    position: '',
    labelWrap: false, // 自动换行
    labelAlign: '',
    columnWidth: '200px',
    // ----
    defaultDict: undefined,
    setting: '', // 组件引用专用字段
    displayFieldName: '', // 名称字段
    dictType: '', // 字典项
    dictDisplayMode: VF_DICT_ENUM.label, // 名称样式
    controlStyle: "select",
    // ----
    customClass: '',
    onValidate: '',
    onMounted: '',
    onChange: '',
    onInitAndUpdate: "",
    onQuery: ''
  }
};
export const singleDict = extendsSchema({
  type: 'jy-dict-list',
  label: '字典列表',
  icon: 'select-field',
  // 加_ 是为了防止使用对应配置组件
  options: { multiple_: true, defaultDict: [] }
}, schema);
// 用于缓存字典接口,防止多次发起请求  key:Promise
export const dict_cache = {};
export async function getDictListByCode(dicCode, force = false) {
  if (dicCode) {
    if (force) dict_cache[dicCode] = undefined;
    const fetch = dict_cache[dicCode] || getVfDictItems({ dicCode });
    dict_cache[dicCode] = fetch;
    const { data } = await fetch;
    return data;
  }
  return [];
}
